export default __webpack_public_path__ + "static/media/bg1.2199f5a3.jpg";